module.exports = __webpack_public_path__ + "media/Do(8va).fa3520df.wav";